<template>
    <div class="suppliersContainer">
        <div class="header">
            <h2>רשימת הספקים</h2>
        </div>
        <div class="section">
            <div class="supplier-box" v-for="(dealer, index) in Dealers" :key="index">
                <div class="supplier-head">
                    <span>{{ dealer.Data.selectDealerName }}</span>
                    <button @click="addTestTransaction"><i class="material-icons">more_vert</i></button>
                </div>
                <div class="supplier-body">
                    <button class="krtest" @click="goToLedger(dealer
                    .ID)">כרטסת ספק</button>
                </div>
            </div>

        </div>
                <!-- <div class="suppliers">
                    <div class="header">
                        <div class="icon">
                            <i class="material-icons">groups</i>
                        </div>
                        <span class="text">רשימת הספקים</span>
                        <div class="searchDiv">
                            <input type="text" placeholder="חיפוש ספקים">
                        </div>
                    </div>
                    <table>
                        <tr>
                            <th></th>
                            <th>שם הספק \ החברה</th>
                            <th>תאריך ההוספה למערכת</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>כלים</th>
                        </tr>
                        <tr v-for="(dealer, index) in Dealers" :key="index">
                            <td>{{ index }}</td>
                            <td>{{ dealer.Data.selectDealerName }}</td>
                            <td>{{ dealer.Data.createdDate }}</td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td><button @click="deleteDealer(dealer)">X</button></td>

                        </tr>
                        <tr >
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>

                        </tr>
                        <tr >
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>

                        </tr>
                        <tr >
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>

                        </tr>
                        <tr >
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>
                            <td></td>

                        </tr>
                        
                        
                    </table>
                </div> -->
    </div>
</template>
<script>
import { db } from '../firebase';
import firebase from "firebase/app";
import moment from 'moment';
import "firebase/storage"
import he from 'moment/locale/he'
export default {
  name: 'Suppliers',
  data () {
    return {
      Dealers:[],

    }
  },
  created(){
    let vm = this;
    if(vm.$root.loggedUser.Type !== 'Admin'){
        alert("אין לך גישה לדף הזה");
        vm.$router.go(-1);
        // vm.$router.back();
    }
    vm.loadDealers();
  },
  methods:{
    loadDealers(){
          let vm = this;
                db.collection("Dealers").where("type", "!=", "עובד")
                .onSnapshot((querySnapshot) => {
                    vm.Dealers = [];
                    querySnapshot.forEach((doc) => {
                      let dealerId = doc.id;
                      let dealer = doc.data();
                      vm.dealersCount = doc.size;
                      vm.Dealers.push({ ID: dealerId, Data: dealer })
                        
                    });
                });

      },
      deleteDealer(dealer){
        let vm = this;
          
          let answer = confirm("האם אתה בטוח למחוק הספק?" );
          
          if (answer){
            db.collection("Dealers").doc(dealer.ID).delete().then(() => {
                console.log("Document successfully deleted!");
                vm.loadDealers();
            }).catch((error) => {
                console.error("Error removing document: ", error);
            });

          }
      },
      async updateAllSuppliers() {
        const snapshot = await db.collection('Dealers').get()

        const batch = db.batch()

        snapshot.forEach(doc => {
            const ref = doc.ref
            batch.update(ref, {
            notes: '',
            totalPurchases: 0,
            totalPayments: 0,
            balance: 0,
            lastActivity: null
            })
        })

        await batch.commit()
        console.log("تم تحديث كل الموردين بنجاح")
    },
    async addTransactionToSupplier(supplierId, transactionData) {
        try {
            const transactionData = {
                type: '', // أو 'payment'
                description: '',
                quantity: 0,
                unitPrice: 0,
                totalAmount: 0,
                paymentMethod: '',
                transactionRef: '',
                attachmentURL: '', // رابط صورة لو موجود
                date: new Date()
            }
            await db
            .collection('Dealers')
            .doc(supplierId)
            .collection('transactions')
            .add({
                ...transactionData,
                createdAt: firebase.firestore.FieldValue.serverTimestamp()
            })

            console.log("تمت إضافة العملية للمورد بنجاح")
        } catch (error) {
            console.error("خطأ أثناء الإضافة:", error)
        }
    },
    goToLedger(id) {
        console.log(id)
        this.$router.push({ name: 'SupplierLedger', params: { id } })
    },
    async  addTestTransaction() {
  const supplierId = '65r08EY2Tj7BZTyWQiDj'
  const db = firebase.firestore()

  await db.collection('Dealers')
    .doc(supplierId)
    .collection('transactions')
    .add({
      type: 'purchase',
      description: 'شراء تجريبي - سكر وطحين',
      quantity: 5,
      unitPrice: 20,
      totalAmount: 100,
      paymentMethod: 'كاش',
      transactionRef: 'TEST123',
      attachmentURL: '',
      date: new Date(),
      createdAt: firebase.firestore.FieldValue.serverTimestamp()
    })

  console.log("✅ تم إضافة المعاملة التجريبية")
}



}
}

</script>
<style>
.suppliersContainer{
    padding: 0 1rem;
    height: 100%;
}
.suppliersContainer .header{
    padding: 1rem 0;
}
.suppliersContainer .header h2{
    font-size: 22px;
}
.section{
    width: 100%;
    padding: 1rem 0;
    column-count: 5;
    gap: 10px;

}
.section .supplier-box{
    width: 100%;
    border: 1px solid #e0e0e0;
    padding: 1rem;
    margin-bottom: 10px;

}
.supplier-box .supplier-head{
    width: 100%;
    font-weight: 500;
    padding-bottom: 1rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;
}
.supplier-head span{
    width: 20ch; /* ✅ يحدد عرض العنصر لـ 10 أحرف */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.supplier-head button{
    border: 0px solid #707070;
    background-color: transparent;
    color:#707070;
    /* padding: 3px 3px; */
    border-radius: 5px;
    font-family: 'Noto Sans Arabic';
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.supplier-head button i{
    font-size:22px ;
    color: #000;
}
.supplier-body{
    padding-top: 1rem ;
}
.supplier-body .krtest{
    padding: 5px 15px;
    border: #418ad4 1px solid ;
    background-color: #418ad4;
    color: #fff;
    font-family: 'Noto Sans Hebrew';
    font-size: 14px;
    border-radius: 5px;
}
.supplier-body .krtest:hover{
    opacity: 0.5;
}















.suppliers{
    width:100% ;
    min-height: 50px;
    background-color: #fff;
    border: #e0e0e0 1px solid;
    border-radius: 8px;
    overflow: hidden;
}
.suppliers .header
{
    width: 100%;
    /* height: 60px; */
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    align-items: center;
    padding: 1rem;
    position: relative;
}

.suppliers .header .icon
{
    padding: 0.5rem;
    border: 1px solid #e0e0e0;
    width:40px;
    height: 40px;
    text-align: center;
    border-radius: 8px;
    background-color: #fff;
}

.suppliers .header .icon i{
    font-size: 20px;
    color: #1c1c1c;
}

.suppliers .header .text{
    font-size: 14px;
    font-weight: 600;
    font-family: 'Noto Sans Hebrew';
    color: #707070;
    margin-right: 10px;
}
.suppliers .header .searchDiv
{
    position: absolute;
    left: 1rem;
}
.suppliers .header .searchDiv input{
    width: 280px;
    border-radius: 8px;
    border:1px solid #e0e0e0;
    padding: 0.3rem 1rem;
    font-size: 13px;
    font-weight: 400;
    color: #707070;
    background-color: #f5f5f5;
    font-family: 'Noto Sans Hebrew';

}

table {
  border-collapse: collapse;
  width: 100%;
}
th{
    color: #1c1c1c;
}
th, td {
  padding: 8px;
  text-align: right;
  border-bottom: 1px solid #ddd;
  font-family: 'Noto Sans Hebrew';
  font-size: 13px;

}
td button {
    padding: 5px 14px;
    border-radius: 8px;
    border: 0;
    background-color: #d11a2a;
    color: #fff;

}
</style>


// WEBPACK FOOTER //
// src/pages/Suppliers.vue